import { createSlice } from "@reduxjs/toolkit";

const buildPackageSlice = createSlice({
  name: "buildPackage",
  initialState: {
    selectedItems: [],
  },
  reducers: {
    addPackageItem(state, action) {
      const newItem = action.payload;
      const exists = state.selectedItems.some((item) => item.id === newItem.id);
      if (!exists) {
        state.selectedItems.push(newItem);
      }
    },

    addPackageItemsBulk(state, action) {
      const newItems = action.payload;
      newItems.forEach((newItem) => {
        const exists = state.selectedItems.some((item) => item.id === newItem.id);
        if (!exists) {
          state.selectedItems.push(newItem);
        }
      });
    },

    removePackageItem(state, action) {
      state.selectedItems = state.selectedItems.filter(
        (item) => item.id !== action.payload
      );
    },

    clearPackageItems(state) {
      state.selectedItems = [];
    },
  },
});

export const {
  addPackageItem,
  addPackageItemsBulk,
  removePackageItem,
  clearPackageItems,
} = buildPackageSlice.actions;
export default buildPackageSlice.reducer;
